import { CaseDocument } from "@/cms/models";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFarm,
  faSection,
  faBuilding,
  faFileLines,
  faHouse,
  faLightbulb,
  faClipboard,
  faPlug,
} from "@fortawesome/sharp-light-svg-icons";
import React from "react";

const getDocumentIcon = (type: string, className: string) => {
  switch (type) {
    case "dk.realequity.ie.file.v2.el_eftersyn":
    case "dk.realequity.ie.file.v2.elinstallationsrapport":
    case "dk.realequity.ie.file.v2.elinstallationsrapport_hovedejendom":
      return <FontAwesomeIcon className={className} icon={faPlug} />;
    case "dk.realequity.ie.file.v2.energimaerkningsrapport":
    case "dk.realequity.ie.file.v2.energimaerkningsrapport_supplerende":
      return <FontAwesomeIcon className={className} icon={faLightbulb} />;
    case "dk.realequity.ie.file.v2.tilstandsrapport":
    case "dk.realequity.ie.file.v2.tilstandsrapport_hovedejendom":
    case "dk.realequity.ie.file.v2.tilstandsrapport_tillaeg":
      return <FontAwesomeIcon className={className} icon={faClipboard} />;
    case "dk.realequity.report.v2.lejeopstilling_bolig_offentlig":
    case "dk.realequity.report.v2.salgsopstilling_ejerbolig_offentlig":
      return <FontAwesomeIcon className={className} icon={faHouse} />;
    case "dk.realequity.report.v2.lejeopstilling_erhverv_offentlig":
    case "dk.realequity.report.v2.salgsopstilling_andelsbolig_offentlig":
    case "dk.realequity.report.v2.salgsopstilling_erhverv_offentlig":
      return <FontAwesomeIcon className={className} icon={faBuilding} />;
    case "dk.realequity.report.v2.salgsopstilling_landbrug_offentlig":
      return <FontAwesomeIcon className={className} icon={faFarm} />;
    case "dk.realequity.ie.file.v2.servitut":
      return <FontAwesomeIcon className={className} icon={faSection} />;
    default:
      return <FontAwesomeIcon className={className} icon={faFileLines} />;
  }
};

const DocumentIcon: React.FC<{
  document: CaseDocument;
  className: string;
}> = ({ document, className }) => {
  return getDocumentIcon(document.namespace, className);
};

export default DocumentIcon;
